// Calgary primary sources cited by the participation explainer.
//
// FR-014: every claim in the explainer block must trace to one entry
// here. FR-019: every cited source on the page must be a Calgary
// primary — the upstream pipeline that mediates the live hearing list
// MUST NEVER appear in any source citation.
//
// These are static facts about how to participate; they don't change
// per-hearing and don't depend on the live feed. The explainer copy
// itself lives in `_components/ParticipationExplainer.tsx`.

export type ParticipationSource = {
  id: string;
  publisher: string;
  title: string;
  url: string;
  retrieved_at: string; // ISO date
  verified_at: string;
  verified_by: string;
  // Plain-language description of which claim in the explainer this
  // source backs. Exposed as the `<a title>` for hover-context.
  claim: string;
};

export const PARTICIPATION_SOURCES: ParticipationSource[] = [
  {
    id: "phmc-public-submissions",
    publisher: "City of Calgary",
    title:
      "Public submission to council, committee or public hearing meeting",
    url: "https://www.calgary.ca/our-services/public-submission.html",
    retrieved_at: "2026-05-09",
    verified_at: "2026-05-09",
    verified_by: "claude+serene",
    claim:
      "Written submissions to a public hearing must be received before 12 noon Calgary time on the eighth day before the meeting; the City's submission form is the canonical channel.",
  },
  {
    id: "phmc-speaker-registration",
    publisher: "City of Calgary",
    title:
      "Public Hearing Meetings of Council — speaker registration and process",
    url: "https://www.calgary.ca/council/meetings.html",
    retrieved_at: "2026-05-09",
    verified_at: "2026-05-09",
    verified_by: "claude+serene",
    claim:
      "Members of the public may speak in person at a public hearing, or remotely by phone, by registering with the City Clerk's office in advance of the meeting.",
  },
];
